import { render, staticRenderFns } from "./MainSlide.vue?vue&type=template&id=3b900c56"
import script from "./MainSlide.vue?vue&type=script&lang=js"
export * from "./MainSlide.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports